import { HStack, VStack } from '@chakra-ui/react';
import { Box, Flex, Image } from '@cmpsr/components';

const industryProofs = {
  width: { base: '150px', md: '212px' },
  height: { base: '63px', md: '89px' },
  p: '15px 21px',
  bg: 'white',
  borderRadius: '10px',
  boxShadow: '0px 4px 14px rgba(0, 0, 0, 0.25)',
  alignItems: 'center',
  justifyContent: 'center',
};

export const IndustryProofs = () => {
  return (
    <Box width={{ base: '100%', lg: '100%' }} pt="10px" bg="tan">
      <HStack spacing="14px" justifyContent="center" display={{ base: 'none', lg: 'flex' }}>
        <Flex {...industryProofs}>
          <Image src="/images/industry-proofs/harvard.svg" />
        </Flex>
        <Flex {...industryProofs}>
          <Image src="/images/industry-proofs/american-cancer-society.svg" />
        </Flex>
        <Flex {...industryProofs}>
          <Image src="/images/industry-proofs/stanford.svg" />
        </Flex>
        <Flex {...industryProofs}>
          <Image src="/images/industry-proofs/american-college-of-radiology.svg" />
        </Flex>
        <Flex {...industryProofs}>
          <Image src="/images/industry-proofs/johns-university.svg" />
        </Flex>
      </HStack>

      <VStack spacing="14px" display={{ base: 'flex', lg: 'none' }}>
        <HStack spacing="14px" justifyContent="center">
          <Flex {...industryProofs}>
            <Image src="/images/industry-proofs/harvard.svg" />
          </Flex>
          <Flex {...industryProofs}>
            <Image src="/images/industry-proofs/american-cancer-society.svg" />
          </Flex>
        </HStack>
        <HStack spacing="14px" justifyContent="center">
          <Flex {...industryProofs}>
            <Image src="/images/industry-proofs/stanford.svg" />
          </Flex>
          <Flex {...industryProofs}>
            <Image src="/images/industry-proofs/johns-university.svg" />
          </Flex>
        </HStack>
      </VStack>
    </Box>
  );
};

export default IndustryProofs;
